<template>
    <span>
        <img :src="`/static/images/icons/reservation/bell_bg_${size}.svg`" title="Optional services" />
    </span>
</template>

<script>
export default {
    name: 'ReservationHasServicesIcon',
    props: {
        size: {
            type: String,
            default: '24'
        },                
    },    
};
</script>
